export class ImageAnnotation extends HTMLElement
{
    annotation = null;
    svgElem = null;

    labelRadius = 30;
    constructor(annotation) {
        super();
        this.annotation = annotation;
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.createAnnotation(this.annotation);
    }

    createAnnotation(annotation) 
    {
        this.dataset.image_id = annotation.image_id;
        this.dataset.marker_number = annotation.marker_number;
        const svgElem = this.createSvgElement();
        this.createAffectedArea(svgElem, annotation);
        this.setDimensions(svgElem, annotation);
        this.createLabel(svgElem, annotation);
        this.classList.add('image-annotation-' + this.annotation.marker_number);
        this.style.opacity = 1;
        this.style.position = 'absolute';
        this.style.transition = 'opacity 0.5s linear';

        this.svgElem = svgElem;
        this.appendChild(svgElem);
        this.setPlacement();
        this.appendChild(svgElem);
        this.loadEventHandlers();
    }

    createSvgElement()
    {
        const svgElem = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svgElem.classList.add('image-annotation');
        svgElem.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        svgElem.setAttribute('version', '1.1');
        
        return svgElem;
    }

    createAffectedArea(svgElem, annotation) {
        const imageScale = this.getImageScale();

        const radius = annotation.radius * imageScale;
        const affectedCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        affectedCircle.classList.add('affected-area-circle');
        affectedCircle.style.fill = '#5ba5d4';
        affectedCircle.style.fillOpacity = 0.5;

        affectedCircle.setAttribute('cx', 0);
        affectedCircle.setAttribute('cy', 0);
        affectedCircle.setAttribute('r', radius);

        svgElem.appendChild(affectedCircle);

        // temp create a circle to show the origin
        const originCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        originCircle.classList.add('origin-circle');
        originCircle.style.fill = 'red';
        originCircle.style.fillOpacity = 1;
        originCircle.setAttribute('cx', 0);
        originCircle.setAttribute('cy', 0);
        originCircle.setAttribute('r', 5);
    }


    createLabel(svgElem, annotation)
    {
        const imageScale = this.getImageScale();
        const x = annotation.radius * imageScale * .5;
        const y = -annotation.radius * imageScale * Math.sqrt(3) / 2;
        const labelCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        labelCircle.classList.add('marker-label');
        labelCircle.setAttribute('cx', x);
        labelCircle.setAttribute('cy', y);
        labelCircle.setAttribute('r', this.labelRadius * imageScale);
        labelCircle.style.fill = '#F3B861';
        labelCircle.style.fillOpacity = '40%';
        svgElem.appendChild(labelCircle);

        const labelText = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        labelText.classList.add('marker-label-text');
        labelText.textContent = annotation.marker_number;
        // place the label at 60 degrees from the + x-axis
        labelText.setAttribute('x', x - 4);
        labelText.setAttribute('y', y + 5); 
        labelText.style.fontSize = '12px';
        labelText.style.fill = 'white';
        labelText.backgroundColor = 'transparent';

        svgElem.appendChild(labelText);
    }

    setDimensions(svgElem, annotation)
    {
        const imageScale = this.getImageScale();
        const radius = annotation.radius * imageScale;
        const labelOffsets = this.calcLabelOffsets(radius, imageScale);
        const x = -(radius);
        const y = -(radius) - labelOffsets.y; // adjust for the label if needed
        let width = (radius * 2) + labelOffsets.x; // adjust for the label if needed
        let height = (radius * 2) + labelOffsets.y; // adjust for the label if needed
        svgElem.setAttribute('viewBox', `${x} ${y} ${width} ${height}`);
        svgElem.style.height = height + 'px';
        svgElem.style.width = width + 'px';
    }


    setPlacement()
    {
        this.setDimensions(this.svgElem, this.annotation);
        this.updateAffectedAreaCircle();
        this.updateLabelPlacement();
        const placementInfo = this.getAnnotationPlacementInfo();

        this.style.top = placementInfo.top + 'px';
        this.style.left = placementInfo.left + 'px';
    }

    loadEventHandlers() 
    {
        window.addEventListener('resize', this.setPlacement.bind(this));

        const vCanvas = document.querySelector('.vetology_canvas');
        vCanvas.addEventListener('cornerstone-invalidated', this.setPlacement.bind(this));

        // listen for marker label click
        const label = this.svgElem.querySelector('.marker-label');
        label.addEventListener('click', this.removeAnnotation.bind(this));
        const text = this.svgElem.querySelector('.marker-label-text');
        text.addEventListener('click', this.removeAnnotation.bind(this));

     }

    updateAffectedAreaCircle()
    {
        const imageScale = this.getImageScale();
        const radius = this.annotation.radius * imageScale;
        const affectedCircle = this.svgElem.querySelector('.affected-area-circle');
        affectedCircle.setAttribute('r', radius);
    }

    updateLabelPlacement()
    {
        const imageScale = this.getImageScale();
        const labelCircle = this.svgElem.querySelector('.marker-label');
        const labelText = this.svgElem.querySelector('.marker-label-text');
        const x = this.annotation.radius * imageScale * .5;
        const y = -this.annotation.radius * imageScale * Math.sqrt(3) / 2;
        labelCircle.setAttribute('cx', x);
        labelCircle.setAttribute('cy', y);
        labelText.setAttribute('x', x - 4);
        labelText.setAttribute('y', y + 5);
    }

    fadeOutTransitionHandler(event)
    {
        this.style.display = 'none';
        this.removeEventListener('transitionend', this.fadeOutTransitionHandler);
    }

    removeAnnotation(event)
    {
        event.preventDefault();
        event.stopPropagation();

        this.addEventListener('transitionend', this.fadeOutTransitionHandler);

        this.style.opacity = 0;
    }

    getAnnotationPlacementInfo() {
        // need to get the bounding rect of the window we are drawing on 
        // and the image size 
        // and the cornerstone viewport that the image is being displayed in
        // also need to account if user is panning image
        const imageScale = this.getImageScale();
        const vCanvas = document.querySelector('.vetology_canvas');
        const boundingRect = vCanvas.getBoundingClientRect();
        const image = cornerstone.getImage(vCanvas);
        const viewport = cornerstone.getViewport(vCanvas);
        const viewportWidth = image.columns * imageScale;
        const viewportHeight = image.rows * imageScale;
        
        let viewPortalLeft = 0;
        let viewPortalTop = 0;

        if (viewport.rotation === 90)
        {
            viewPortalLeft = (boundingRect.width - viewportHeight) / 2 + viewport.translation.x * imageScale;
            viewPortalTop = (boundingRect.height - viewportWidth) / 2 + viewport.translation.y * imageScale;
        } else if (viewport.rotation === 270)
        {
            viewPortalLeft = (boundingRect.width - viewportHeight) / 2 + viewport.translation.x * imageScale;
            viewPortalTop = (boundingRect.height - viewportWidth) / 2 + viewport.translation.y * imageScale;
        } else {
            viewPortalLeft = (boundingRect.width - viewportWidth) / 2 + viewport.translation.x * imageScale;
            viewPortalTop = (boundingRect.height - viewportHeight) / 2 + viewport.translation.y * imageScale;
        }

        let markerCenterX = 0;
        let markerCenterY = 0;
        if (viewport.hflip)
        {
            markerCenterX = (image.columns - this.annotation.center[0]) * imageScale + viewPortalLeft;
        } else {
            markerCenterX = this.annotation.center[0] * imageScale + viewPortalLeft;
        }

        if (viewport.vflip) {
            markerCenterY = (image.rows - this.annotation.center[0]) * imageScale + viewPortalTop;
        } else {
            markerCenterY = this.annotation.center[1] * imageScale + viewPortalTop;
        }

        if (viewport.rotation === 90)
        {
            if (viewport.vflip) {
                markerCenterX = this.annotation.center[1] * imageScale + viewPortalLeft;
            } else {
                markerCenterX = (image.rows - this.annotation.center[1]) * imageScale + viewPortalLeft;
            }
            if (viewport.hflip) {
                markerCenterY = (image.columns - this.annotation.center[0]) * imageScale + viewPortalTop;
            } else {
                markerCenterY = this.annotation.center[0] * imageScale + viewPortalTop;
            }
        } else if (viewport.rotation === 180)
        {
            if (viewport.hflip)
            {
                markerCenterX = this.annotation.center[0] * imageScale + viewPortalLeft;
            } else {
                markerCenterX = (image.columns - this.annotation.center[0]) * imageScale + viewPortalLeft;
            }
            if (viewport.vflip) {
                markerCenterY = this.annotation.center[1] * imageScale + viewPortalTop;
            } else {
                markerCenterY = (image.rows - this.annotation.center[1]) * imageScale + viewPortalTop;
            }
        } else if (viewport.rotation === 270)
        {
            if (viewport.vflip) {
                markerCenterX = (image.rows - this.annotation.center[1]) * imageScale + viewPortalLeft;
            } else {
                markerCenterX = this.annotation.center[1] * imageScale + viewPortalLeft;
            }
            if (viewport.hflip) {
                markerCenterY = this.annotation.center[0] * imageScale + viewPortalTop;
            } else {
                markerCenterY = (image.columns - this.annotation.center[0]) * imageScale + viewPortalTop;
            }
        }
        
        // adjust for the marker's width and height 
        let markerLeft = markerCenterX - this.annotation.radius * imageScale;
        let markerTop = markerCenterY - this.annotation.radius * imageScale;



        return {
            left: markerLeft,
            top: markerTop,
            scale: imageScale
        };
    }

    getImageScale()
    {
        const vCanvas = document.querySelector('.vetology_canvas');
        const viewport = cornerstone.getViewport(vCanvas);
        return viewport.scale;
    }

    calcLabelOffsets(annotationRadius, imageScale)
    {
        let offsets = {
            x: 0,
            y: 0    
        };
        if (annotationRadius * .5 + this.laberRadius * imageScale > annotationRadius)
        {
            offsets.x = annotationRadius * .5 + this.labelRadius * imageScale - annotationRadius;
        }
        if (annotationRadius * Math.sqrt(3) / 2 + this.labelRadius * imageScale > annotationRadius)
        {
            offsets.y = annotationRadius * Math.sqrt(3) / 2 + this.labelRadius * imageScale - annotationRadius;
        }

        return offsets;
    }

    getCornerstoneViewPort()
    {
        const vCanvas = document.querySelector('.vetology_canvas');
        const viewPort = cornerstone.getViewport(vCanvas);

        return viewPort;
    }

    toggleAnnotation(event)
    {
        const visible = parseInt(this.style.opacity);

        if (!visible) {
            this.style.display = 'block';
        } else {
            this.addEventListener('transitionend', this.fadeOutTransitionHandler);
        }

        setTimeout(() => {
            this.style.opacity = visible === 0 ? 1 : 0;
        }, 100);
    }

    flash()
    {
        this.style.display = 'block';
        this.style.opacity = 1;
        this.style.animation = "blinker .5s linear infinite";
        setTimeout(() => {
            this.style.animation = 'none';
        }, 2000);
    }

}

customElements.define('image-annotation', ImageAnnotation);
